import { useDictionary } from "contexts/Dictionary"
import {
  ListRoot,
  ListWrapper,
  TitleRow,
  TitleLine,
  InnerList,
  FlexLi,
  SuggestionResultLine,
  ScreenReaderDiv,
} from "./styles"

const listVariants = {
  hidden: { height: 0 },
  visible: {
    height: "auto",
    transition: { staggerChildren: 0.07 },
  },
}

const itemVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { opacity: 1, x: 0 },
}

export default function Suggestions({ suggestions, onSelect }) {
  const dictionary = useDictionary()

  if (!suggestions?.length) return null

  return (
    <ListRoot initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0, overflow: "hidden" }}>
      <ListWrapper>
        <TitleRow>
          <TitleLine id="suggestionsLabel" variants={itemVariants}>
            {dictionary.suggestions()}
          </TitleLine>
        </TitleRow>
        <ScreenReaderDiv aria-live="polite" className="sr-only">
          {`${suggestions.length} ${dictionary.ariaLiveSuggestions()}`}
        </ScreenReaderDiv>
        <InnerList initial="hidden" animate="visible" variants={listVariants} aria-labelledby="suggestionsLabel">
          {suggestions.map(suggestion => (
            <FlexLi key={suggestion.rawValue} variants={itemVariants}>
              <SuggestionResultLine
                type="button"
                onClick={() => onSelect(suggestion.rawValue)}
                dangerouslySetInnerHTML={{ __html: suggestion.highlightedValue }}
              />
            </FlexLi>
          ))}
        </InnerList>
      </ListWrapper>
    </ListRoot>
  )
}
